import { render, staticRenderFns } from "./ConnectionEditDialog.vue?vue&type=template&id=8c5f8274&scoped=true"
import script from "./ConnectionEditDialog.vue?vue&type=script&lang=ts"
export * from "./ConnectionEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConnectionEditDialog.vue?vue&type=style&index=0&id=8c5f8274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5f8274",
  null
  
)

export default component.exports